var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSleeping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 101,
    viewBox: "0 0 161 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.563 86.6094C135.563 94.164 129.3 100.416 121.732 100.416C114.164 100.416 107.901 94.164 107.901 86.6094C107.901 79.0548 114.164 72.8027 121.732 72.8027C129.561 73.0632 135.563 79.0548 135.563 86.6094Z",
    fill: "#3D0E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6559 10.6443C46.0499 8.17216 49.9983 8.10536 52.4749 10.4951C62.46 20.1303 64.3049 36.5824 57.4418 48.3268C50.5309 60.1532 35.3704 66.2658 22.2167 62.6549C22.1882 62.6471 22.1598 62.6391 22.1315 62.6309C11.9976 59.694 3.96224 51.6282 0.729948 41.9485C-0.359298 38.6865 1.40672 35.1608 4.67446 34.0734C7.9422 32.9861 11.4742 34.749 12.5635 38.011C14.5458 43.9474 19.5397 48.8975 25.5665 50.6606C33.2819 52.7554 42.6252 48.97 46.6674 42.0528C50.7649 35.041 49.4782 24.9217 43.8054 19.4477C41.3289 17.0579 41.2619 13.1165 43.6559 10.6443Z",
    fill: "#3D0E6B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.055 1.87679C117.688 4.09412 118.021 8.02199 115.8 10.6499C110.594 16.8092 110.188 26.9685 114.823 33.5237C119.445 40.0599 129.215 43.0408 136.717 40.1603C136.748 40.1486 136.778 40.1371 136.809 40.1259C142.391 38.0829 146.845 32.6628 148.27 26.3646C149.028 23.0106 152.367 20.9057 155.727 21.663C159.087 22.4203 161.196 25.7532 160.437 29.1072C158.211 38.9452 151.201 48.1004 141.149 51.7995C128.305 56.7051 112.528 51.869 104.633 40.7043C96.742 29.5453 97.3803 13.1332 106.266 2.62027C108.488 -0.00767133 112.422 -0.340542 115.055 1.87679Z",
    fill: "#3D0E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSleeping);
export default __webpack_public_path__ + "static/media/face_sleeping.5d57f80cb7f3614f4b697c82241d057d.svg";
export { ForwardRef as ReactComponent };